import { CommingSoon } from "./components/CommonComponents/ComingSoon";
import Dashboard from "./components/Dashboard/Dashboard";
import EventMaster from "./components/Master/EventMaster";
import ClientMaster from "./components/Master/ClientMaster";
import UpdateCandidateData from "./components/Master/UpdateCandidateData";
import UploadCandidateData from "./components/Master/UploadCandidateData";
import UploadCandidateFile from "./components/Master/UploadCandidateFile";
import CandidateReport from "./components/Report/CandidateReport";
import SMSReport from "./components/Report/SMSReport";
import DownloadAdmitCard from "./components/Master/DownloadAdmitCard";
import DownloadLogReports from "./components/Master/DownloadLogs";

const AppRoutes = [
    {
        path: '*',
        element: CommingSoon
    }, {
        path: '/Master/ClientMaster',
        element: ClientMaster
    }, {
        path: '/Master/Eventmaster',
        element: EventMaster
    },
    {
        path: 'Report/DownloadData',
        element: DownloadAdmitCard
    }, {
        path: '/Dashboard/Dashboard',
        element: Dashboard
    }, {
        path: '/Upload/UploadCandidateFile',
        element: UploadCandidateFile
    }, {
        path: '/Update/UpdateCandidateData',
        element: UpdateCandidateData
    }, {
        path: '/Upload/UploadCandidateData',
        element: UploadCandidateData
    }, {
        path: 'Report/CandidateReport',
        element: CandidateReport
    }, {
        path: 'Report/SMSReport',
        element: SMSReport
    },{
        path: 'Report/DownloadLogReport',
        element: DownloadLogReports
    }
];

export default AppRoutes;
